import Vue from "vue";
import Vuex from "vuex";

import {
    getItem,
    setItem
} from "@/utils/storage";

Vue.use(Vuex);
const def = '8c8d7ef25e25fdf8e30cbb617b271a98'
export default new Vuex.Store({
    state: {
        nthUserInfo: getItem("nthUserInfo"),
        token: getItem("token"),
        cardFlag: getItem("cardFlag"),
        deviceToken: getItem("deviceToken"),
        city: getItem("city"),
        limit: getItem("limit"),
        goodsInfo: {},
        isTimeOver: false,
        isGet: false,
        isPayed: false,
        isFinish: false,
        isStart: false,
        isEmpty: false,
        countDownTime: 0,
        awaitBuyTime: 0,
    },
    mutations: {
        setGoodsInfo(state, goodsInfo) {
            state.goodsInfo = {...goodsInfo}
        },
        setIsTimeOver(state, bool) {
            state.isTimeOver = bool
        },
        setIsGet(state, bool) {
            state.isGet = bool
        },
        setIsPayed(state, bool) {
            state.isPayed = bool
        },
        setIsFinish(state, bool) {
            state.isFinish = bool
        },
        setIsStart(state, bool) {
            state.isStart = bool
        },
        setIsEmpty(state, bool) {
            state.isEmpty = bool
        },
        setCountDownTime(state, time) {
            state.countDownTime = time
        },
        setAwaitBuyTime(state, time) {
            state.awaitBuyTime = time
        },
        setNthUserInfo(state, nthUserInfo) {
            state.nthUserInfo = nthUserInfo;
            setItem("nthUserInfo", nthUserInfo);
        },

        setUserTokenKey(state, data) {
            state.token = data;
            setItem("token", data);
        },
        setCardFlag(state, data) {
            state.cardFlag = data;
            setItem("cardFlag", data);
        },

        setDeviceToken(state, data) {
            state.deviceToken = data;
            setItem("deviceToken", data);
        },
        setCity(state, data) {
            state.city = data;
            setItem("city", data);
        },

        setPayLimit(state, data) {
            state.limit = data;
            setItem("limit", data);
        },

    },
    actions: {
        awaitBuyTimer({commit}, timer) {
            let time = null
            let _timer = parseInt(timer / 1000)
            time = setInterval(() => {
                if (_timer <= 1) {
                    commit("setIsGet", false)
                    clearInterval(time)
                }
                _timer--
            }, 1000)

        },
    },
    modules: {},
});